export const schema = {
  title: 'Назначить замер',
  type: 'object',
  fields: [
    {
      name: 'measurement_responsible',
      required: true,
      title: 'Ответственный за замер',
      options: {
        showSearch: true,
      },
      input: {
        type: 'string',
        view: {
          name: 'select-from-enum',
        },
      },
    },
    {
      name: 'measurement_date',
      required: true,
      title: 'Дата замера',
      options: {
        disabled: true,
        isDisabledDatePrev: true,
      },
      input: {
        type: 'string',
        format: 'date',
      },
    },
    {
      name: 'measurement_time',
      required: true,
      title: 'Время замера',
      options: {
        disabled: true,
        multiple: true,
        allowSelectAll: false,
      },
      input: {
        type: 'string',
        view: {
          name: 'select-from-enum',
        },
      },
    },
    {
      name: 'comment',
      title: 'Комментарий',
      input: {
        type: 'string',
      },
      options: {
        type: 'textarea',
        minRows: 3,
        maxRows: 5,
      },
    },
    {
      name: 'send_tg_notification',
      input: {
        type: 'boolean',
      },
      options: {
        label: 'Отправить уведомление в Телеграмм',
      },
    },
  ],
}
